export const getPermissionAction = "GLOBAL/LOAD_PERMISSION";
export const getPermissionSuccessAction = "GLOBAL/LOAD_PERMISSION/SUCCESS";
export const getPermissionFailAction = "GLOBAL/LOAD_PERMISSION/FAIL";
